export default __webpack_public_path__ + "static/media/twitter.58ad62c2.webp";